module.exports = __webpack_public_path__ + "img/inumber.00ceb6e7.svg";